import HomeAdminPage from "./HomeAdminPage";

export {HomeAdminPage}
export default HomeAdminPage
